<template>
    <transition name="fade">
      <div
        v-show="isOverlayActive"
        class="black-overlay"
        :style="{
          'z-index': zIndex,
        }"
        @click="handleClickOverlay"
      />
    </transition>
  </template>
  
  <script>
  export default {
    name: 'BlackOverlay',
    computed: {
      isOverlayActive() {
        return this.$store.state.Interface.overlay.isActive;
      },
      zIndex() {
        return this.$store.state.Interface.overlay.zIndex;
      },
    },
    methods: {
      handleClickOverlay() {
        this.$store.dispatch('Interface/setOverlayDeactive');
      },
    },
  }
  </script>
  
  <style lang="scss" scoped>
  .black-overlay {
    display: block;
    -ms-filter: progid:DXImageTransform.Microsoft.Alpha(opacity=68);
    filter: alpha(opacity = 68);
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: 150;
    background: rgba(0,0,0,0.7);
    // backdrop-filter: blur(20px);
  }
  .fade-enter-active, .fade-leave-active {
    transition: opacity .3s ease;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
  </style>